import { useEffect, useState } from "react";
import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";
import CookiePreferencesModal from "./CookiePreferencesModal";
import { initializeTrackingScripts } from "./cookieGate";

const CookieConsentModal = () => {
  // 🔥 THE FIX: Lazily initialize state straight from localStorage on application mount!
  const [showPreferences, setShowPreferences] = useState(() => {
    return localStorage.getItem("showCookiePreferencesModal") === "true";
  });

  // Check on page load if tracking is already approved
  useEffect(() => {
    initializeTrackingScripts();
  }, []);

  const savePreferences = (preferences) => {
    localStorage.setItem("cookiePreferences", JSON.stringify(preferences));
    setShowPreferences(false);
    localStorage.removeItem("showCookiePreferencesModal");

    // Instantly run or adjust scripts when checkboxes change
    initializeTrackingScripts();
  };

  const handleAccept = () => {
    const defaultPreferences = {
      essential: true,
      analytics: true,
      marketing: true,
      functional: true,
    };
    savePreferences(defaultPreferences);
  };

  const handleDecline = () => {
    setShowPreferences(true);
    localStorage.setItem("showCookiePreferencesModal", "true");
  };

  return (
    <>
      {/* 1. Main Bottom Notice Cookie Bar Element Channel */}
      <div id="cookie-consent">
        <CookieConsent
          location="bottom"
          buttonText="Accept All Cookies"
          cookieName="twigaCookies"
          expires={150}
          enableDeclineButton
          declineButtonText="Customize Options"
          onAccept={handleAccept}
          onDecline={handleDecline}
          buttonWrapperClasses="cookie-action-buttons-row"
        >
          <div className="cookie-content">
            <h4>This website uses cookies</h4>
            We use cookies that are essential for the website to operate, for
            analytics, functionality and ads. To find out more, read our{" "}
            <Link to="/cookie-policy">Cookie Policy</Link>
          </div>
        </CookieConsent>
      </div>

      {/* 2. 🔥 THE FIX: Move preferences popup modal OUTSIDE the parent ID container */}
      {showPreferences && (
        <CookiePreferencesModal savePreferences={savePreferences} />
      )}
    </>
  );
};

export default CookieConsentModal;

// Error: Calling setState synchronously within an effect can trigger cascading renders Effects are intended to synchronize state between React and external systems such as manually updating the DOM, state management libraries, or other platform APIs. In general, the body of an effect should do one or both of the following: * Update external systems with the latest state from React. * Subscribe for updates from some external system, calling setState in a callback function when external state changes. Calling setState synchronously within an effect body causes cascading renders that can hurt performance, and is not recommended.

// import { useEffect, useState } from "react";
// import CookieConsent from "react-cookie-consent";
// import { Link } from "react-router-dom";
// import CookiePreferencesModal from "./CookiePreferencesModal";
// import { initializeTrackingScripts } from "./cookieGate";

// const CookieConsentModal = () => {
//   const [showPreferences, setShowPreferences] = useState(false);

//   // Check state on mount
//   useEffect(() => {
//     const preferencesOpen = localStorage.getItem("showCookiePreferencesModal");
//     if (preferencesOpen === "true") {
//       setShowPreferences(true);
//     }

//     // 🔥 NEW: Check on page load if tracking is already approved
//     initializeTrackingScripts();
//   }, []);

//   const savePreferences = (preferences) => {
//     localStorage.setItem("cookiePreferences", JSON.stringify(preferences));
//     setShowPreferences(false);
//     localStorage.removeItem("showCookiePreferencesModal");

//     // 🔥 NEW: Instantly run or adjust scripts when checkboxes change
//     initializeTrackingScripts();
//   };

//   const handleAccept = () => {
//     const defaultPreferences = {
//       essential: true,
//       analytics: true,
//       marketing: true,
//       functional: true,
//     };
//     savePreferences(defaultPreferences);
//   };

//   const handleDecline = () => {
//     setShowPreferences(true);
//     localStorage.setItem("showCookiePreferencesModal", "true"); // Set modal state in localStorage
//   };

//   return (
//     <>
//       {/* 1. Main Bottom Notice Cookie Bar Element Channel */}
//       <div id="cookie-consent">
//         <CookieConsent
//           location="bottom"
//           buttonText="Accept All Cookies"
//           cookieName="twigaCookies"
//           expires={150}
//           enableDeclineButton
//           declineButtonText="Customize Options"
//           onAccept={handleAccept}
//           onDecline={handleDecline}
//           buttonWrapperClasses="cookie-action-buttons-row"
//         >
//           <div className="cookie-content">
//             <h4>This website uses cookies</h4>
//             We use cookies that are essential for the website to operate, for
//             analytics, functionality and ads. To find out more, read our{" "}
//             <Link to="/cookie-policy">Cookie Policy</Link>
//           </div>
//         </CookieConsent>
//       </div>

//       {/* 2. 🔥 THE FIX: Move preferences popup modal OUTSIDE the parent ID container */}
//       {showPreferences && (
//         <CookiePreferencesModal savePreferences={savePreferences} />
//       )}
//     </>
//   );
// };

// export default CookieConsentModal;
